import React from 'react';
import styled from 'styled-components';
import Content from 'gatsby-theme-core/src/components/content';
import Image from 'gatsby-theme-core/src/components/image';
import Stars from '../../../../components/styled-stars';

const ReviewPreview = ({
  className,
  title,
  reviewerImage,
  content,
  score,
  maximumScore,
}) => (
  <article className={className}>
    <Main>
      <Title>{title}</Title>
      <Content $content={content} />
      <StyledStars
        $starsColor="#FFA52F"
        $starsColorBackground="#D7D7D7"
        $score={score}
        $maximumScore={maximumScore}
      />
    </Main>
    <div>
      <StyledImage image={reviewerImage} />
    </div>
  </article>
);

const StyledStars = styled(Stars)`
  margin-top: auto;
  padding-top: 1rem;
`;

const StyledImage = styled(Image)`
  border-radius: 50%;
  width: 64px;
  height: 64px;
`;

const Main = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.strong`
  display: block;
  padding-bottom: .5rem;
  font-size: 1.25rem;
  line-height: 150%;
`;

export default styled(ReviewPreview)`
  background-color: ${({ theme }) => theme.grayLightColor};
  border: 1px solid ${({ theme }) => theme.grayLightColor};
  border-radius: ${({ theme }) => theme.borderRadius};
  display: grid;
  gap: 0.5rem;
  grid-template-columns: minmax(0, 1fr) auto;
  padding: 1rem;
`;
